/******************************************************************************

BabiGO
Notification Empty State
========================

*/

import {

FiBell

} from "react-icons/fi";

import "./notificationEmpty.css";

export default function NotificationEmpty({

    title = "Aucune notification",

    message = "Vous n'avez aucune nouvelle notification pour le moment.",
    
    }) {

        return (

            <div

                className="notification-empty"

                role="status"

                aria-live="polite"

            >

                <div className="notification-empty-icon">

                    <FiBell />

                </div>


                <div className="notification-empty-content">

                    <h4 className="notification-empty-title">

                        {title}

                    </h4>


                    <p className="notification-empty-message">

                        {message}

                    </p>

                </div>

            </div>

        );
    }
